<script setup lang="ts">
const { scale = 1 } = defineProps<{
    scale?: number;
}>();
</script>

<template>
    <div class="sk-fading-circle" :style="{ transform: `scale(${scale})` }">
        <div class="sk-circle1 sk-circle" />
        <div class="sk-circle2 sk-circle" />
        <div class="sk-circle3 sk-circle" />
    </div>
</template>

<style lang="scss" scoped>
.sk-fading-circle {
    width: 16px;
    height: 5px;
    position: relative;
    margin: 3px auto 0;
}

.sk-fading-circle .sk-circle {
    width: 4px;
    height: 4px;
    position: absolute;
    top: 0;
}

.sk-fading-circle .sk-circle1 {
    left: 0;
}
.sk-fading-circle .sk-circle2 {
    left: 6px;
}

.sk-fading-circle .sk-circle3 {
    left: 12px;
}

.sk-fading-circle .sk-circle:before {
    content: '';
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    background-color: usePalette();
    border-radius: 100%;
    -webkit-animation: sk-circleFadeDelay 0.8s infinite ease-in-out both;
    animation: sk-circleFadeDelay 0.8s infinite ease-in-out both;
}
.sk-fading-circle .sk-circle2:before {
    -webkit-animation-delay: -0.7s;
    animation-delay: -0.7s;
}
.sk-fading-circle .sk-circle3:before {
    -webkit-animation-delay: -0.6s;
    animation-delay: -0.6s;
}

@keyframes sk-circleFadeDelay {
    0%,
    39%,
    100% {
        opacity: 0.1;
    }
    40% {
        opacity: 1;
    }
}
</style>
